import {

	// TopCollections component
	TopCollectionsworkc1,
	TopCollectionsworkc2,
	TopCollectionsworkc3,
	TopCollectionsworkc4,


} from '../../utils/allImgs'

import paladinNft from '../../assets/paladin_nft.png';
import mantisNFT from '../../assets/mantis_nft.png';
import lotusNFT from '../../assets/lotus_nft.png';
import sabersNFT from '../../assets/sabers_nft.png';

export const TopCollectionsData = [
	{
		img:paladinNft,//paladinNft,
		title:'Paladin Class Ship',
		text:'Edition: 1 - Card #4',
		Delay:'300'
	},
	{
		img:mantisNFT,//mantisNFT,
		title:'Mantis Class Ship',
		text:'Edition: 1 - Card #5',
		Delay:'500'
	},
	{
		img:lotusNFT,//lotusNFT,
		title:'Lotus Class Ship',
		text:'Edition: 1 - Card #3',
		Delay:'600'
	},
	{
		img:sabersNFT,//sabersNFT,
		title:'Eredne Sabres',
		text:'Edition: 1 - Card #1',
		Delay:'700'
	}
]


// export {data1 , data2 , data3}